export default {
    transferDeckCN(data) {
        switch (data) {
            case 1:
                return "一层"
            case 2:
                return "二层"
            case 3:
                return "三层"
            case 4:
                return "四层"
            case 5:
                return "五层"
            case 6:
                return "六层"
            case 7:
                return "七层"
            case 8:
                return "八层"
            case 9:
                return "九层"
            case 10:
                return "十层"
            case 11:
                return "十一层"
            case 12:
                return "十二层"
            case 13:
                return "十三层"
            case 14:
                return "十四层"
            case 15:
                return "十五层"
            case 16:
                return "十六层"


            default: return ""

        }
    },
    getDeckByStateroom(stateroom) {
        if (stateroom.substr(0, 1) == 1) {
            return stateroom.substr(0, 2);
        } else {
            return stateroom.substr(0, 1);
        }
    }
}
